import { render, staticRenderFns } from "./cfgManager.vue?vue&type=template&id=0990ecbb&scoped=true"
import script from "./cfgManager.vue?vue&type=script&lang=js"
export * from "./cfgManager.vue?vue&type=script&lang=js"
import style0 from "./cfgManager.vue?vue&type=style&index=0&id=0990ecbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0990ecbb",
  null
  
)

export default component.exports